<template>
  <div :class="themeClass" class="splash-screen">
    <img :style="placeLogoAtTheCenter()" :src="logoSrc" alt="Logo" />

    <!-- <p>{{ t('splash.loading') }} {{ progress }}%</p>--> 

    <div class="progress-container" v-if="isLoading" :style="loadingBorder">
      <div class="progress-bar" :style="loadingBarColor+';width:'+ progress + '%;'" ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useAppStore } from '@/stores/appStore'
import { useI18n } from 'vue-i18n'
import { db } from '../plugins/firebase';
import { collection, getDocs } from 'firebase/firestore';

defineOptions({ name: 'LoadingPage' })

const appStore = useAppStore()

const props = defineProps({
  theme: { type: String, default: 'dark' },
  language: { type: String, default: 'en' },
  user: { type: String },
  environment: { type: String }
})

// Set i18n locale
const { t, locale } = useI18n()
locale.value = props.language

const progress = ref(0)
const isLoading = ref(true)

onMounted(async () => {
  const gameData = []
  let loaded = 0
  let total = 0
  let fakeProgress = 0

  const querySnapshot = await getDocs(collection(db, 'games'))
  total = querySnapshot.docs.length

  for (const doc of querySnapshot.docs) {
    const game = { id: doc.id, ...doc.data() }
    if (game.active && (props.environment !== 'production' || !game.devOnly)) {
      gameData.push(game)
    }
    loaded++
  }
  // === 1. Fake progress up to 60%
  const fakeTimer = setInterval(() => {
    if (fakeProgress < 100) {
      fakeProgress += 1
      progress.value = fakeProgress

    }
    else {
      if(loaded==total){
        fakeProgress = 100
        isLoading.value = false
        progress.value = fakeProgress
        console.log('loading finished, all games are saved')
        //console.log(gameData)
        appStore.setGames(gameData)
        clearInterval(fakeTimer)
      }
    }

  }, 10) 
})

// Handle dynamic screen size
const width = ref(window.innerWidth)
const height = ref(window.innerHeight)

// Watch for window resize
window.addEventListener('resize', () => {
  width.value = window.innerWidth
  height.value = window.innerHeight
})

// Compute the logo style
function placeLogoAtTheCenter() {
  const logoSize = Math.round(Math.min(width.value, height.value) / 2)
  let loaderCss = `position:absolute;width:${logoSize}px;height:${logoSize}px;`
  loaderCss += `top:${(height.value - logoSize) / 2}px;`
  loaderCss += `left:${(width.value - logoSize) / 2}px;`
  return loaderCss
}

// Compute the logo path based on theme
const logoSrc = computed(() =>
  props.theme === 'light'
    ? new URL('./../assets/receiver-light.png', import.meta.url).href
    : new URL('./../assets/receiver-dark.png', import.meta.url).href
)

const loadingBarColor = computed(() =>
  props.theme === 'light'
    ? 'background-color:rgb(205, 115, 114)'
    : 'background-color:rgb(255, 247, 178)'
)

const loadingBorder = computed(() =>
  props.theme === 'light'
    ? 'border: 2px solid rgb(205, 115, 114)'
    : 'border: 2px solid rgb(255, 247, 178)'
)

const themeClass = computed(() => (props.theme === 'light' ? 'light' : 'dark'))

</script>

<style scoped>
.splash-screen {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: var(--bg-color);
  color: var(--text-color);
}

.dark {
  --bg-color: #000;
  --text-color: #fff;
}

.light {
  --bg-color: #fff;
  --text-color: #000;
}

.splash-text {
  position: absolute;
  bottom: 30px;
  width: 100%;
  text-align: center;
  font-size: 1.2em;
}

.progress-container {
  position: absolute;
  bottom: 30px;
  left: 10%;
  width: 80%;
  /*background-color: #ccc;
  border-color: ;*/
  border-radius: 16px;
  overflow: hidden;
  height: 16px;
}

.progress-bar {
  height: 100%;
  transition: width 0.2s ease;
}

.splash-screen p {
  text-align: center;
  margin-top: 10px;
  color: var(--text-color);
}
</style>
